import { Box } from 'theme-ui';

const LayoutContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Box css={{ width: '100%' }}>{children}</Box>;
};

export default LayoutContainer;
